<div [ngSwitch]="type">
  <div *ngSwitchCase="'outlined'" [class]="'outlined-notification-box ' + boxClassName">
    <div class="outlined-notification-box__icon">
      <i *ngIf="!iconImage && !!iconClass" [class]="iconClass"></i>
      <img [src]="iconImage" [class]="iconClass" alt="outlined-notification-box-sybmol" />
    </div>
    <div class="outlined-notification-box__body">
      <p *ngIf="!!headerTitle" class="outlined-notification-box__title">
        {{ headerTitle | translate }}
      </p>
      <div class="outlined-notification-box__description">
        <span *ngIf="!!innerHtmlDescription; else normalDescriptionContainer" [innerHTML]="innerHtmlDescription | translate"></span>
        <ng-template #normalDescriptionContainer>
          <span>{{ description | translate }}</span>
        </ng-template>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="'info'" [class]="'info-notification-box ' + boxClassName">
    <div class="info-notification-box__icon">
      <i *ngIf="!iconImage && !!iconClass" [class]="iconClass"></i>
      <img [src]="iconImage" [class]="iconClass" alt="info-notification-box-sybmol" />
    </div>
    <div class="info-notification-box__body">
      <p *ngIf="!!headerTitle" class="info-notification-box__title">
        {{ headerTitle | translate }}
      </p>
      <div class="info-notification-box__description">
        <span *ngIf="!!innerHtmlDescription; else normalDescriptionContainer" [innerHTML]="innerHtmlDescription | translate"></span>
        <ng-template #normalDescriptionContainer>
          <span>{{ description | translate }}</span>
        </ng-template>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="'filled'" [class]="'filled-notification-box ' + boxClassName" [ngClass]="{ closed: !open && isAnimated }">
    <div class="filled-notification-box__graphic">
      <img class="filled-notification-box__graphic__image" [src]="iconImage" alt="filled-notification-box-graphic" />
    </div>

    <div class="filled-notification-box__body">
      <span *ngIf="!!badgeText" class="filled-notification-box__badge">
        {{ badgeText | translate | uppercase }}
      </span>

      <p *ngIf="!!headerTitle" class="filled-notification-box__title">
        {{ headerTitle | translate }}
      </p>

      <div class="filled-notification-box__description">
        <span *ngIf="!!innerHtmlDescription; else normalDescriptionContainer" [innerHTML]="innerHtmlDescription | translate"></span>
        <ng-template #normalDescriptionContainer>
          <span>{{ description | translate }}</span>
        </ng-template>
      </div>

      <div class="filled-notification-box__hint">
        <span *ngIf="!!innerHtmlHint; else normalHintContainer" [innerHTML]="innerHtmlHint | translate"></span>
        <ng-template #normalHintContainer>
          <span>{{ hint | translate }}</span>
        </ng-template>
      </div>
    </div>

    <div class="filled-notification-box__action">
      <button class="filled-notification-box__action__button btn btn-link" (click)="onConfirm()">
        {{ "BUTTON.GOT_IT" | translate }}
      </button>
    </div>
  </div>
</div>
